@use "../../styles/breakpoint.module.scss" as *;
@use "../../styles/layout.module.scss" as l;

.root {
    composes: grid from "../../styles/layout.module.scss";
    grid-column: 1 / -1;
    position: relative;
    width: 100%;
    overflow: hidden;
}

.screen {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: subgrid;
    align-items: center;
    text-align: center;
}

.screenOne {
    composes: screen;
    padding-top: var(--spacer-64);
    position: relative;
}

.screenTwo {
    composes: screen;
    height: 150vh;

    @media ($below-tablet) {
        height: 130vh;
    }

    @media ($below-mobile) {
        height: 100vh;
    }
}

.textInner {
    composes: fullwidth from "../../styles/layout.module.scss";
    display: flex;
    flex-direction: column;
    align-items: center;
}

.screenTwo .textInner > div {
    max-width: l.span(6);

    @media ($below-tablet) {
        max-width: l.span(8);
    }

    @media ($below-mobile) {
        max-width: none;
    }
}

.eyebrow {
    composes: fontST24 from "../../styles/typography.module.scss";
    font-weight: 800;
    margin-bottom: var(--spacer-16);
}

.title {
    composes: fontHB144 from "../../styles/typography.module.scss";
    font-weight: 500;
    max-width: 40ch;
    text-wrap-style: balance;
    margin-bottom: var(--spacer-24);
}

.body {
    composes: fontP20 from "../../styles/typography.module.scss";
    font-weight: 400;
    max-width: 720px;
    text-wrap-style: balance;
    margin-bottom: var(--spacer-24);
}

.textInner > :last-child {
    margin-bottom: 0;
}

.cards {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1;
    pointer-events: none;
    display: grid;
    grid-template-columns:
        var(--actual-margin) repeat(var(--grid-column-count), minmax(0, 1fr))
        var(--actual-margin);
    column-gap: var(--grid-gap);
    grid-template-rows: 1fr;

    @media ($below-mobile) {
        display: block;
    }
}

.cardOne,
.cardTwo,
.cardThree {
    grid-row: 1;
    align-self: start;
    width: 100%;
    aspect-ratio: 3 / 4;
    border-radius: var(--border-radius-md);
    overflow: hidden;
    will-change: transform;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }

    @media ($below-mobile) {
        position: absolute;
        width: l.span(2);
    }
}

.cardOne {
    grid-column: 11 / span 3;
    margin-top: var(--spacer-104);

    @media ($below-mobile) {
        // Left edge lines up with the left edge of col 6 — extends off-screen.
        left: calc(
            100% - var(--actual-margin) - var(--grid-gap) - var(
                    --grid-column-width
                )
        );
        margin-top: var(--spacer-104);
    }
}

.cardTwo {
    grid-column: 2 / span 3;
    margin-top: 70vh;

    @media ($below-tablet) {
        margin-top: 45vh;
    }

    @media ($below-mobile) {
        // Right edge lines up with the right edge of col 1 — extends off-screen.
        right: calc(
            100% - var(--actual-margin) - var(--grid-gap) - var(
                    --grid-column-width
                )
        );
        margin-top: 45vh;
    }
}

.cardThree {
    grid-column: 11 / span 3;
    margin-top: 107.5vh;

    @media ($below-mobile) {
        left: calc(
            100% - var(--actual-margin) - var(--grid-gap) - var(
                    --grid-column-width
                )
        );
        margin-top: 75vh;
    }
}
